<template>
  <div class="account-damage-display">
    <div class="card-header bg-default">
      <span class="mr-1 fa fa-wrench"></span>
      Damage Details
      <span v-if="!damage.resolved" class="badge badge-danger">
        Unresolved
      </span>
      <span v-if="damage.resolved" class="badge badge-success">
        Resolved
      </span>
      <span v-if="!damage.repaired" class="badge badge-danger">
        Unrepaired
      </span>
      <span v-if="damage.repaired" class="badge badge-success">
        Repaired
      </span>
    </div>
    <ul class="list-group list-group-flush">
      <li class="list-group-item" v-if="damage.Account">
        <span class="mr-1 fa fa-user"></span>
        <router-link :to="`/membership/members/${damage.Account.uuid}`">
          {{ damage.Account.dropdownLabel }}
        </router-link>
      </li>
      <li class="list-group-item" v-if="damage.Car">
        <span class="fa fa-car mr-1"></span>
        <router-link :to="`/fleet/vehicles/${damage.Car.uuid}`">
          {{ damage.Car.dropdownLabel }}
        </router-link>
      </li>
      <li class="list-group-item" v-if="damage.Reservation">
        <span class="fa fa-calendar-alt mr-1"></span>
        <router-link
        :to="`/fleet/reservations/${damage.Reservation.uuid}`">
          Reservation #{{ damage.Reservation.reservationId }}
        </router-link>
      </li>
      <li class="list-group-item" v-if="damage.resolved">
        <template v-if="damage.AdminResolved">
          <span class="fas fa-clipboard-check mr-1"></span>
          <router-link :to="`/membership/members/${damage.AdminResolved.uuid}`">
            {{ damage.AdminResolved.dropdownLabel }}
          </router-link>
        </template>
      </li>
      <div class="list-group-item list-group-item-success" v-if="damage.repaired">
        <p>
          <strong>Repaired by:</strong>
          <template v-if="damage.AdminRepaired">
            <router-link :to="{ path: '/membership/members/' + damage.AdminRepaired.uuid }">
              {{ damage.AdminRepaired.dropdownLabel }}
            </router-link>
          </template>
          <br>
          <span class="fa fa-clock mr-1"></span> {{ damage.dateRepaired | short_date_format }}<br/>
        </p>
        <p>
          <strong>Repair Cost:</strong> {{ damage.repairCost | to_dollar_amount }}<br/>
          <strong>Insurance Claim Made: </strong> {{ damage.insuranceClaim ? 'Yes' : 'No' }}<br/>
          <p><strong>Notes:</strong></p>
          <span v-html="nl2br(damage.repairDescription)"></span>
        </p>
      </div>
    </ul>
    <div class="card-body">
      <h6 class="card-subtitle mb-2 text-muted">
        <span class="fa fa-clock"></span> {{ damage.dateLogged | date_format('Australia/Melbourne') }}
      </h6>
      <div class="card-text" v-html="nl2br(damage.description)"></div>
      <template v-if="damage.AmazonImages && damage.AmazonImages.length">
        <hr>
        <p class="card-title"><span class="fa fa-paperclip mr-1"></span> Attachments</p>
        <template v-for="(image, index) in damage.AmazonImages">
          <a v-if="image.objectKey.includes('pdf')" target="_blank" :key="index"
          :href="`https://techcar-dev.s3.amazonaws.com/${image.objectKey}`">
            PDF {{ index + 1 }}
          </a>
          <a v-else target="_blank" :key="index"
          :href="`https://techcar-dev.s3.amazonaws.com/${image.objectKey}`">
            <img :src="`https://techcar-dev.s3.amazonaws.com/${image.objectKey}`" class="img-fluid img-thumbnail mb-2" />
          </a>
        </template>
      </template>
    </div>
    <div class="card-footer clearfix">
      <em class="align-middle" v-if="damage.AdminResponsible">
        <strong>Admin Responsible: </strong>
        <router-link
        :to="`/membership/members/${damage.AdminResponsible.uuid}`">
          {{ damage.AdminResponsible.dropdownLabel }}
        </router-link>
      </em>
      <em class="align-middle" v-else>System Generated</em>
      <div class="float-right">
        <button class="btn btn-success btn-sm" type="button"
        @click="resolveCarDamage" v-if="!damage.resolved">
          <span class="fa fa-check"></span> Mark As Resolved
        </button>
        <button class="btn btn-warning btn-sm" type="button"
        @click="repairDamageModal" v-if="!damage.repaired">
          <span class="fa fa-wrench"></span> Mark As Repaired
        </button>
      </div>
    </div>
  </div>
</template>

<script>
  import { RESOLVE_DAMAGE, REPAIR_DAMAGE } from '@/vuex/types'
  export default {
    name: 'CarDamageCard',
    props: {
      object: {
        type: Object
      }
    },
    computed: {
      damage () {
        return {
          ...this.object,
          ...this.updatedDamage
        }
      }
    },
    data () {
      return {
        updatedDamage: {}
      }
    },
    methods: {
      nl2br (message) {
        return this.$root.$options.filters['nl2br'](message)
      },
      async resolveCarDamage () {
        let result = await this.$store.dispatch(RESOLVE_DAMAGE, this.damage.uuid)
        this.updatedDamage = result
      },
      repairDamageModal () {
        this.$store.dispatch(REPAIR_DAMAGE, this.damage.uuid)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/cards/CarDamage.vue